import './App.css';
import oldHome from './components/oldHome';
import Home from './components/Home';
import Resume from './components/Resume';
import Button from './components/Button';
import { BrowserRouter, Routes, Route} from 'react-router-dom';

//Try to move particles to home.js later

// Try to transition between pages without changing the links !!!
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element = {<Home />} />
        <Route path='/oldHome' element = {<oldHome />} />
        <Route path='/Resume' element = {<Resume />} />
      </Routes>
    </BrowserRouter>

    //
    //<BMW3D id="BMW" />
    // The lines aboves works well as a standalone, but does not work together with the other elements. 
    // Smth about JSX elements only 1 parent, try to investigate later for when I use 3D model
    // Try to make sure that everything can fit into 1 frame, 1 page

    // Also learn WTF Dom is
  );
}
